import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=1517d99a&scoped=true&"
import script from "./Palette.vue?vue&type=script&lang=js&"
export * from "./Palette.vue?vue&type=script&lang=js&"
import style0 from "./Palette.vue?vue&type=style&index=0&id=1517d99a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1517d99a",
  null
  
)

export default component.exports